@let selectedOptions = selectedOptions$ | async;
@let times = filteredOptions | async;
@let viewportHeight = viewportHeight$ | async;

<mat-form-field
  subscriptSizing="dynamic"
  class="w-full">
  <input
    #timeInput
    type="text"
    matInput
    rmsInputMask
    [mask]="timeMask"
    [formControl]="timeControl"
    [placeholder]="placeholder"
    [matAutocomplete]="auto"
    (keydown.enter)="onEnterKeyPress()" />

  <mat-icon
    matSuffix
    [ngClass]="{ 'opacity-40': timeControl.disabled }"
    svgIcon="remix:System/time-line" />

  <mat-autocomplete
    class="overflow-hidden"
    #auto="matAutocomplete"
    [hideSingleSelectionIndicator]="true"
    (opened)="onPanelOpened()"
    (optionSelected)="timeControl.patchValue($event.option.value)">
    <cdk-virtual-scroll-viewport
      [itemSize]="ITEM_SIZE"
      [style.height.px]="viewportHeight">
      <mat-option
        *cdkVirtualFor="let time of times"
        [class.mdc-list-item--selected]="selectedOptions === time"
        [value]="time">
        {{ time }}
      </mat-option>
    </cdk-virtual-scroll-viewport>
  </mat-autocomplete>
</mat-form-field>
